import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { SiteList, PubList } from '../FormComponents';
import { SiteEntry, PubListEntry,upPubListEntry } from '../../services/interfaces';
import { getNextPubNum, getPubList, savePub, deletePub } from '../../services/apiAdminService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';

interface PageState {
    skip: number;
    take: number;
}

const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{field:"isActivePub", dir:"desc"},{ field: 'pubName', dir: 'asc' }],
};

interface editProps{
    pub:PubListEntry,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewPubEntry{
    pubName:string,
    pubNum:number,
    tmpChar:SiteEntry,
    tmpChar2:string,
    isActivePub:number,
    isArchivePub:number,
    killDelay:number,
    killPath:string,
    opiPath:string,
    opiPathA:string,
    purgeDelay:number,
    tmpInt1:number,
    tmpInt2:number,
    autoToning:string,
    archiveName:string,
    duplicatePubNum:string
}


const EditDialog=(props:editProps)=>{

    const [newPub, setNewPub]= useState<NewPubEntry>(
        {
            pubName:"",
            pubNum:-2,
            tmpChar:{
                code:"",
                name:"",
                logo_Prefix:"",
                primary_ip:"",
                backup_ip:"",
                temp_Char:"",
                temp_Int:"",
                vol1_Unc_Path:"",
                vol2_Unc_Path:""
            },
            tmpChar2:"",
            isActivePub:0,
            isArchivePub:0,
            killDelay:0,
            killPath:"",
            opiPath:"",
            opiPathA:"",
            purgeDelay:0,
            tmpInt1:0,
            tmpInt2:0,
            autoToning:"",
            archiveName:"",
            duplicatePubNum:""
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");

    const [isArchive, setIsArchive]=useState<boolean>(false);
    const [isActive, setIsActive]=useState<boolean>(false);
    const [isAutoIncrement, setisAutoIncrement]=useState<boolean>(false);
    const [showDupConfirm, setShowDupConfirm]=useState(false);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showCopyButton, setShowCopyButton]=useState(true);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");

    const [pubValid, setPubValid]=useState({
        pubNum:false,
        pubName:false,
        pubSite:false
    });
    const setPubName=(e: InputChangeEvent|string)=>{
        if (typeof(e)=="string"){
            setNewPub({...newPub, pubName: (e as string) || ''})
        }else{
            setNewPub({...newPub, pubName: (e.target.value as string) || ''})
        }        
    }

    const validatePub= async()=>{
        var pubValid={
            pubNum:false,
            pubName:false,
            pubSite:false
        }
        if (newPub.pubNum>-1){
            pubValid.pubNum=true;
        }
        if (newPub.pubName!==""){
            pubValid.pubName=true;            
        }
        if (newPub.tmpChar.code!==""){
            pubValid.pubSite=true;
        }
        return pubValid;
    }


    const setPubNum=(pub:number)=>{
        setNewPub({...newPub, pubNum: (pub)})
    }

    const setDupPubNum=(pub:number)=>{
        setNewPub({...newPub, duplicatePubNum: (pub.toString())})
    }

    const setSiteCode=(site:SiteEntry[])=>{
        console.log(site);
        setNewPub({...newPub, tmpChar: (site[0]) || ''})
    }

    const setPurgeDelay=(e: InputChangeEvent)=>{
        setNewPub({...newPub, purgeDelay: Number(e.target.value) || 0})
    }

    const setKillDelay=(e: InputChangeEvent)=>{
        setNewPub({...newPub, killDelay: Number(e.target.value) || 0})
    }
    const setKillPath=(e: InputChangeEvent)=>{
        setNewPub({...newPub, killPath: (e.target.value as string) || ''})
    }

    const setOPIPath=(e: InputChangeEvent)=>{
        setNewPub({...newPub, opiPath: (e.target.value as string) || ''})
    }
    const setOPIPathA=(e: InputChangeEvent)=>{
        setNewPub({...newPub, opiPathA: (e.target.value as string) || ''})
    }

    const setPubType=(e: DropDownListChangeEvent)=>{
        setNewPub({...newPub, tmpChar2: (e.target.value as string) || ''})
    }

    const setAutoToning=(e: DropDownListChangeEvent)=>{
        setNewPub({...newPub, autoToning: (e.target.value as string) || ''})
    }

    const setArchivePub=(pub: string[])=>{
        console.log(pub);
        //setNewPub({...newPub, archiveName: pub[0] || ''});
    }

    const setAutoIncremement=(e:SwitchChangeEvent)=>{
        console.log(e.value);
        if (e.value==true){
            setNewPub({...newPub, tmpInt2: (1)});
            setisAutoIncrement(true);
        }
        else{
            setNewPub({...newPub, tmpInt2: (0)});
            setisAutoIncrement(false);
        }
    }

    const setIsArchivePub=(e:SwitchChangeEvent)=>{
        console.log(e.value);
        if (e.value===true){
            setIsArchive(true);
            setIsActive(false);
        }
        else{
            setIsArchive(false);
        }
    }

    const setIsActivePub=(e:SwitchChangeEvent)=>{
        console.log(e.value);
        if (e.value===true){
            setIsArchive(false);
            setIsActive(true);            
        }
        else{
            setIsActive(false);
        }
    }

    const pubType:string[] = ["PRINT","ONLINE","MAGAZINE","SPEC"];
    const autoToning:string[] = ["PRINT","ONLINE","MAGAZINE"];

    const showDupConfirmWarning = (e: React.MouseEvent<HTMLButtonElement>) => {
        setShowDupConfirm(true);
    }

    const hideCopyButton=()=>{
        setShowCopyButton(false);
    }
    const viewCopyButton=()=>{
        setShowCopyButton(true);
    }

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }

    const hideDupConfirmWarning=()=>{
        setShowDupConfirm(false);
    }

    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    const confirmDuplicate=()=>{
        getNextPubNum().then(data=>{
            console.log(data);
            setNewPub({...newPub, duplicatePubNum:(props.pub.pubNum.toString()), pubNum:data, pubName:""});
            setIntAction("New");
            setDlgTitle("Duplicating " + props.pub.pubName + "(" + props.pub.pubNum + ") to new pub " + data);
            hideCopyButton();
            hideDeleteButton();
            hideDupConfirmWarning();
        });
    }


    const deleteThisPub=()=>{
        if (props.action=="Edit"){
            const pubNum = newPub.pubNum;
            const pubName = newPub.pubName;
            if (pubName!="" && pubNum>-1){
                deletePub(pubNum.toString(),pubName);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }



    const saveThisPub= async ()=>{

        var oPubNum;
        var oPubName;
        var active;
        var archive;
        validatePub().then((pubValid)=>{
            if (pubValid.pubName===true && pubValid.pubNum===true && pubValid.pubSite===true){
                if (intAction==="Edit"){
                    //edit existing pub
                    oPubNum=props.pub.pubNum;
                    oPubName=props.pub.pubName;
                }else{
                    //create new pub
                    oPubNum=-1;
                    oPubName="";
                }
                if (isActive===true){
                    active=1;
                }else{
                    active=0;
                }
                if (isArchive===true){
                    archive=1;
                }else{
                    archive=0;
                }

                var formData:upPubListEntry = {
                    oPubNum:oPubNum,
                    oPubName:oPubName,
                    pubName:newPub.pubName,
                    pubNum:newPub.pubNum,
                    tmpChar:newPub.tmpChar.code,
                    tmpChar2:newPub.tmpChar2,
                    isActivePub:active,
                    isArchivePub:archive,
                    killDelay:newPub.killDelay,
                    killPath:newPub.killPath,
                    opiPath:newPub.opiPath,
                    opiPathA:newPub.opiPathA,
                    purgeDelay:newPub.purgeDelay,
                    tmpInt1:newPub.tmpInt1,
                    tmpInt2:newPub.tmpInt2,
                    autoToning:newPub.autoToning,
                    archiveName:newPub.archiveName,
                    duplicatePub:newPub.duplicatePubNum
                };
                console.log(formData);
                savePub(formData).then((data)=>{
                    console.log(data);
                    props.onClose();
                });    
            }else{
                console.log("Missing fields");
            }    
        });
        
    }

    useEffect(()=>{
        console.log(newPub);
        if (newPub.isActivePub===1){
            setIsActive(true);
        }else{
            setIsActive(false);
        }
        if (newPub.isArchivePub===1){
            setIsArchive(true);
        }else{
            setIsArchive(false);
        }
        if (newPub.tmpInt2===1){
            setisAutoIncrement(true);
        }else{
            setisAutoIncrement(false);
        }
    }, [newPub]);

    useEffect(() => {  
        setDlgTitle(props.title); 
        if (props.pub){
            setNewPub({
                pubName:props.pub?.pubName||"",
                pubNum:props.pub.pubNum,
                tmpChar:{
                    code:props.pub.tmpChar,
                    name:"",
                    logo_Prefix:"",
                    primary_ip:"",
                    backup_ip:"",
                    temp_Char:"",
                    temp_Int:"",
                    vol1_Unc_Path:"",
                    vol2_Unc_Path:""
                },
                tmpChar2:props.pub.tmpChar2,
                isActivePub:props.pub.isActivePub,
                isArchivePub:props.pub.isArchivePub,
                killDelay:props.pub.killDelay,
                killPath:props.pub.killPath,
                opiPath:props.pub.opiPath,
                opiPathA:props.pub.opiPathA,
                purgeDelay:props.pub.purgeDelay,
                tmpInt1:props.pub.tmpInt1,
                tmpInt2:props.pub.tmpInt2,
                autoToning:props.pub.autoToning,
                archiveName:props.pub.archiveName,
                duplicatePubNum:""
            })
            
            //setNewPub(props.pub);
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewCopyButton();
            viewDeleteButton();
        }else{
            hideCopyButton();
            hideDeleteButton();
        }
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"90vh"}>
            {showDupConfirm?<ConfirmDialog title='Duplicate Publication' message='This will copy all the settings for the selected publication to a new publication. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDupConfirmWarning} onConfirm={confirmDuplicate}  ></ConfirmDialog>:null}
            {showDelConfirm?<ConfirmDialog title='Delete Publication' message='This will permanently delete the selected publication. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisPub}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Pub Name:</Label></Col>
                <Col xs="9"><Input value={newPub.pubName} onChange={setPubName} maxLength={50} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Site Code:</Label></Col>
                <Col xs="9"><SiteList setReturnAction={setSiteCode} value={newPub.tmpChar} multi={false} valid={true} className=''></SiteList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Archive Pub:</Label></Col>
                <Col xs="9"><PubList setReturnAction={setArchivePub} value={[newPub.archiveName]} type="Single" archiveOnly={true} liveOnly={false} siteFilter='' className='' returnField='num' onlineOnly={false} printOnly={false}></PubList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Purge Delay:</Label></Col>
                <Col xs="9"><Input value={newPub.purgeDelay} onChange={setPurgeDelay}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Kill Delay:</Label></Col>
                <Col xs="9"><Input value={newPub.killDelay} onChange={setKillDelay}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Kill Path:</Label></Col>
                <Col xs="9"><Input value={newPub.killPath} onChange={setKillPath} maxLength={150}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>OPI Path:</Label></Col>
                <Col xs="9"><Input value={newPub.opiPath} onChange={setOPIPath} maxLength={150}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>OPI Path A:</Label></Col>
                <Col xs="9"><Input value={newPub.opiPathA} onChange={setOPIPathA} maxLength={150}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Pub Type:</Label></Col>
                <Col xs="9"><DropDownList data={pubType} value={newPub.tmpChar2} onChange={setPubType} fillMode={"outline"}/></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Auto Toning:</Label></Col>
                <Col xs="9"><DropDownList data={autoToning} value={newPub.autoToning} onChange={setAutoToning} fillMode={"outline"}/></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={isAutoIncrement} onChange={setAutoIncremement}></Switch>&emsp;<Label className='mb-2'>Auto Incremement</Label></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={isActive} onChange={setIsActivePub}></Switch>&emsp;<Label className='mb-2'> This is a live, active pub</Label></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={isArchive} onChange={setIsArchivePub}></Switch>&emsp;<Label className='mb-2'> This is an archive pub</Label></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisPub}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
                {showCopyButton?<Button themeColor={"warning"} onClick={showDupConfirmWarning}>Copy to New Pub</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminPubs (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [pubs, setPubs] = useState([]);
    const [pubSelected, setPubSelected]=useState<PubListEntry>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(pubs,dataState));
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const idGetter = getter('pubNum');

    const setSelectedPub=(pub:PubListEntry)=>{
        setPubSelected(pub);
    }

    const hideEditDialog=()=>{
        setShowEditDialog(false);
        getPubs();
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        getNextPubNum().then(data=>{
            setPubSelected({
                pubName:"",
                pubNum:data,
                tmpChar:"",
                tmpChar2:"",
                isActivePub:0,
                isArchivePub:0,
                killDelay:0,
                killPath:"",
                opiPath:"",
                opiPathA:"",
                purgeDelay:0,
                tmpInt1:0,
                tmpInt2:0,
                autoToning:"",
                archiveName:""
            });
            setTitle("New Publication (" + data + ")");
            setShowEditDialog(true);
        })
    }



    const getPubs=()=>{
        getPubList().then(data=>{
            setPubs(data);
            setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        setDataResult(process(pubs, e.dataState));
    };
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;        
        setPage({
            ...event.page,
            take:20
        });
    }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const pub:PubListEntry=event.startDataItem;
        setSelectedPub(pub);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "pubNum"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        if (pubSelected){
            setTitle("Publication Configuration for: " + pubSelected?.pubName + " (" + pubSelected?.pubNum + ")");
            setShowEditDialog(true);
        }
    },[pubSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            getPubs();
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Publication Management</h2>
            <Toolbar>
                <Button title="New Publication" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Publication
                </Button>       
            </Toolbar>
            <Grid
                data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                    ...item, 'selected':selectedState[idGetter(item)]
                }))}
                dataItemKey='pubNum'
                id="pubGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                skip={page.skip}
                take={page.take}
                total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='pubNum' title='Pub ID' width={200} />
                <GridColumn field='pubName' title='Pub Name'/>
                <GridColumn field='tmpChar2' title='Pub Type'/>
                <GridColumn field='autoToning' title='Auto Toning'/>
                <GridColumn field='archiveName' title='Archive Name'/>
                <GridColumn field='isActivePub' title='Is Active'/>
                <GridColumn field='isArchivePub' title='Is Archive'/>                
                <GridColumn field='tmpChar' title='Site'/>                
            </Grid>
            {showEditDialog?
                <EditDialog title={title} pub={pubSelected as PubListEntry} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}